import React from 'react';
import { useTranslation } from 'react-i18next';
import { Building2, Network, Shield, MapPin } from 'lucide-react';
import { Button } from '../components/Button';

export function ColocationPage() {
  const { t } = useTranslation();

  const handleQuoteRequest = () => {
    window.location.href = 'mailto:quotes@synthohosting.net?subject=Colocation Quote Request';
  };

  return (
    <div className="pt-16">
      <div className="bg-gradient-to-br from-blue-900 to-blue-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-6">{t('colocation.title')}</h1>
          <p className="text-xl text-blue-100">
            {t('colocation.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Building2 className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">{t('colocation.features.datacenter.title')}</h3>
            <p className="text-gray-600">{t('colocation.features.datacenter.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Network className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">{t('colocation.features.connectivity.title')}</h3>
            <p className="text-gray-600">{t('colocation.features.connectivity.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <Shield className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">{t('colocation.features.security.title')}</h3>
            <p className="text-gray-600">{t('colocation.features.security.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg">
            <MapPin className="w-12 h-12 text-blue-600 mb-4" />
            <h3 className="text-xl font-bold mb-2">{t('colocation.features.location.title')}</h3>
            <p className="text-gray-600">{t('colocation.features.location.description')}</p>
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg text-center">
          <Button variant="primary" onClick={handleQuoteRequest}>
            {t('common.getQuote')}
          </Button>
        </div>
      </div>
    </div>
  );
}